import ModalAuth from '@/components/modals/ModalAuth';
import ModalAvatarInfo from '@/components/modals/ModalAvatarInfo';
import ModalAppSetting from '@/components/modals/ModalAppSetting';
import ModalCast from '@/components/modals/ModalCast';
export const mobileModalMap = {
};

export const pcModalMap = {
    ModalAuth,
    ModalAvatarInfo,
    ModalAppSetting,
    ModalCast
};
